





























import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import {
  LegalSectionData,
  LegalSectionMethods,
  LegalSectionComputed,
  LegalSectionProps,
} from './LegalSection';
/**
 * `Legal Section Footer` - Legal Section Footer for OneWeb - Legal Section contains the legal information of the website, this components exists inside the Lower Footer Component
 */

export default ComponentInitializeDispatcher.extend<
  LegalSectionData,
  LegalSectionMethods,
  LegalSectionComputed,
  LegalSectionProps
>({
  name: 'owc-legal-section',
  mixins: [OwcDataComponent],
  computed: {
    legalItems: function() {
      return this.componentData?.items;
    },
    legalLicense: function() {
      return this.componentData?.license;
    },
  },
});
